module.exports = __webpack_public_path__ + "img/atlanta_ga.715c8dfc.jpg";